import * as XLSX from 'xlsx';

type DownloadExcelFromHtmlProps = {
  htmlString: string;
  fileName: string;
};

export const downloadExcelFromHtml = ({
  htmlString,
  fileName,
}: DownloadExcelFromHtmlProps) => {
  const container = document.createElement('div');
  container.innerHTML = htmlString;

  const table = container.querySelector('table');

  if (!table) {
    console.error('No table found in HTML string');
    return;
  }

  const workbook = XLSX.utils.table_to_book(table, { sheet: 'Socios' });

  XLSX.writeFile(workbook, fileName);
};
